import { render, staticRenderFns } from "./wizard-buttons.vue?vue&type=template&id=2d15226b"
import script from "./wizard-buttons.vue?vue&type=script&lang=js"
export * from "./wizard-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports